import { z } from 'zod';
// =============================================================================
// Document text (the chat agent's readDocument tool)
// =============================================================================
/**
 * Strict like every request schema, but it declares `idempotencyKey`: the chat adapter adds one
 * to every fileInput query. Reading creates nothing, so the key is accepted and ignored.
 */
export const ReadDocumentQuerySchema = z.strictObject({
    idempotencyKey: z.string().optional(),
    firstPage: z.coerce.number().int().min(1).optional().describe('First page to read, 1-based. Defaults to 1.'),
    lastPage: z.coerce
        .number()
        .int()
        .min(1)
        .optional()
        .describe('Last page to read, 1-based. Defaults to the end of the document, within the per-read page and character caps.'),
});
export const PdfUnreadableReasonSchema = z.enum(['NO_TEXT', 'ENCRYPTED', 'DAMAGED', 'NOT_A_PDF']);
const ReadDocumentSourceSchema = z.literal('user-attached file');
export const ReadDocumentResponseSchema = z.discriminatedUnion('status', [
    z.object({
        status: z.literal('READ'),
        source: ReadDocumentSourceSchema,
        pageCount: z.number().int(),
        firstPage: z.number().int(),
        lastPage: z.number().int(),
        pages: z.array(z.object({ page: z.number().int(), text: z.string() })),
        truncated: z.boolean(),
        nextPage: z.number().int().nullable(),
    }),
    z.object({
        status: z.literal('UNREADABLE'),
        source: ReadDocumentSourceSchema,
        reason: PdfUnreadableReasonSchema,
        pageCount: z.number().int().nullable(),
        message: z.string(),
    }),
]);
